<template>
  <div>
    <div
      class=" overflow-y-auto  mt-4"
      ref="messageChat"
      style="max-height: 500px"
    >
      <ul>
        <li
          v-for="(message, idx) in comments"
          :key="idx"
          v-bind:class="{ 'border-t border-vectric': idx > 0 }"
        >
          <topic-message
            :message="message"
            v-on:remove-message="handleRemoveMessage"
            v-on:replying-to="handleReplyingTo"
          ></topic-message>
        </li>
      </ul>
    </div>
    <div class="mt-4">
      <disabled-activity v-if="!allowActivity" />
      <div
        v-if="replyToSummary"
        class="bg-vectric  rounded  text-sm my-2  flex p-2 items-center border-white border"
      >
        <div class="mr-2 cursor-pointer" @click="handleCancelReply">
          <svg
            class="w-6 h-6 text-black hover:text-yellow"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </div>
        <span class="font-semibold">
          Replying to:
        </span>
        <span class="ml-2 text-base" v-html="replyToSummary"> </span>
      </div>

      <form @submit.prevent="onSubmit" v-if="loggedIn && allowActivity">
        <div class=" flex rounded-md shadow-sm relative">
          <picker
            @select="addEmoji"
            title="Pick your emoji"
            emoji="point_up"
            :native="true"
            v-show="showEmojiWindow"
          />
          <textarea
            ref="responseRef"
            v-model="responseInput"
            id="about"
            rows="3"
            @input="$emit('input', $event.target.value)"
            class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          ></textarea>
        </div>
        <div class="mt-2 flex flex-row align-center">
          <span class="inline-flex rounded-md shadow-sm">
            <button type="submit" class="standard-btn" :disabled="isDisabled">
              Post
            </button>
          </span>
          <span class="inline-flex rounded-md shadow-sm ml-2">
            <button
              type="button"
              class="standard-btn"
              @click="
                () => {
                  showEmojiWindow = !showEmojiWindow;
                }
              "
            >
              <svg
                class="h-6 w-6 stroke-current"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            </button>
          </span>
        </div>
      </form>
      <if-can-take-part login-class="border border-purple shadow-xl">
        <div></div>
      </if-can-take-part>
    </div>
  </div>
</template>

<script>
import { Picker } from "emoji-mart-vue";
import { auth, firebase, projectCommentsCollection } from "../utils/firebase";
import TopicMessage from "./TopicMessage";
import { mapGetters } from "vuex";
import { removeSessionComment } from "../utils/functions";
import IfCanTakePart from "./IfCanTakePart";
import DisabledActivity from "./DisabledActivity";
import { truncate } from "../utils/truncate";
export default {
  name: "SessionCommentArea",
  components: {
    IfCanTakePart,
    Picker,
    TopicMessage,
    DisabledActivity
  },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      responseInput: "",
      showEmojiWindow: false,
      unsubscribeFn: null,
      comments: [],
      replyingTo: null
    };
  },
  computed: {
    ...mapGetters(["loggedIn", "allowActivity"]),
    isDisabled() {
      return (
        this.responseInput === undefined ||
        this.responseInput == null ||
        this.responseInput.trim().length == 0
      );
    },
    replyToSummary() {
      if (this.replyingTo) {
        return truncate(this.replyingTo.body, 60);
      }
      return "";
    }
  },
  methods: {
    handleReplyingTo(message) {
      console.log(message);
      this.replyingTo = message;
    },

    handleCancelReply() {
      this.replyingTo = null;
    },

    handleSentMessage() {
      this.replyingTo = null;
    },
    //
    // Fetch Messages
    //
    fetchMessages() {
      this.comments = [];
      this.unsubscribeFn = projectCommentsCollection
        .where("session", "==", this.session._id)
        .orderBy("timestamp", "asc")
        .onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            const doc = change.doc;

            if (change.type === "added") {
              this.comments.push({ id: doc.id, ...doc.data() });
            }
            if (change.type === "modified") {
              const index = this.comments.findIndex(item => item.id === doc.id);
              this.comments.splice(index, 1, { id: doc.id, ...doc.data() });
            }
            if (change.type === "removed") {
              const index = this.comments.findIndex(item => item.id === doc.id);
              this.comments.splice(index, 1);
            }
          });
        });
    },

    //
    // Submit Form
    //
    onSubmit() {
      // TODO: Verification

      let comment = {
        body: this.responseInput,
        user: auth.currentUser.uid,
        userDisplay: auth.currentUser.displayName,
        session: this.session._id,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      };

      if (this.replyingTo) {
        comment.replyingTo = {
          messageSummary: truncate(this.replyingTo.body, 60),
          userDisplay: this.replyingTo.userDisplay,
          id: this.replyingTo.id
        };
      }

      projectCommentsCollection
        .add(comment)
        .then(() => {
          this.responseInput = "";
          this.handleSentMessage();
        })
        .catch(err => console.error(err));
    },

    //
    // Handle the removal of messages
    //
    handleRemoveMessage(commentID) {
      this.$store.dispatch("setDeletedMessageId", commentID);
      removeSessionComment(commentID);
    },

    //
    // Add an emoji and reset the cursor
    //
    addEmoji(emoji) {
      const textarea = this.$refs.responseRef;
      const cursorPosition = textarea.selectionEnd;
      const start = this.responseInput.substring(0, textarea.selectionStart);
      const end = this.responseInput.substring(textarea.selectionStart);
      const text = start + emoji.native + end;
      // this.$emit('input', text)
      this.responseInput = text;
      textarea.focus();
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.native.length;
      });
      this.showEmojiWindow = false;
    }
  },
  beforeDestroy() {
    if (this.unsubscribeFn) {
      this.unsubscribeFn();
    }
  },
  created() {
    this.fetchMessages();
  }
};
</script>
<style scoped>
.emoji-mart {
  position: absolute;
  top: -400px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
